import React, { JSX, ReactElement } from "react";
import { Trans, useTranslate } from "@obsbot/remo-i18n";
import ChannelLayoutContainer from "../ChannelLayoutContainer";
import { Avatar } from "antd";
import "./index.less";

interface ChannelOutterProps {
    channelName: string;
    channelCount: number;
    avatars: string[];
    hasChannel: boolean;
    onClickJoinChannel: () => void;
    onClickCreateChannel: () => void;
}

const ChannelOutterPage: React.FC<ChannelOutterProps> = ({
    channelName,
    channelCount,
    avatars,
    hasChannel,
    onClickJoinChannel,
    onClickCreateChannel,
}): ReactElement => {
    const t = useTranslate();
    return (
        <div className="channel-outter-page">
            <div className="content-info">
                <div className="name">{hasChannel ? channelName : t("noChannel")}</div>
                <div className="desc">
                    {hasChannel ? (
                        channelCount === 0 ? (
                            <span>{t("noPeopleChannelDescription")}</span>
                        ) : (
                            <span>
                                <Trans
                                    components={{
                                        count: (
                                            <span
                                                className="channel-count"
                                                style={{
                                                    color: "var(--normal-white)",
                                                    padding: "0 4px",
                                                }}
                                            />
                                        ),
                                    }}
                                    i18nKey="channelDescription"
                                    values={{ number: channelCount }}
                                />
                            </span>
                        )
                    ) : (
                        t("noChannelDescription")
                    )}
                    {channelCount !== 0 && hasChannel && (
                        <div className="show-avatars">
                            <Avatar.Group shape="circle">
                                {avatars.map((avatar, idx) => (
                                    <Avatar key={avatar + idx} size={36} src={avatar} />
                                ))}
                            </Avatar.Group>
                        </div>
                    )}
                </div>
                {hasChannel ? (
                    <div className="addChannelBtn" onClick={onClickJoinChannel}>
                        {t("joinChannel")}
                    </div>
                ) : (
                    <div className="createChannelBtn" onClick={onClickCreateChannel}>
                        {t("emptyCreateChannel")}
                    </div>
                )}
            </div>
        </div>
    );
};

export default function ChannelHomePage(): JSX.Element {
    return <ChannelLayoutContainer Component={ChannelOutterPage} />;
}
